import React, { useState } from "react";
import { login } from "../services/api";
import { useAuth } from "../context/AuthContext";

export default function LoginPage() {
  const { setSession } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const data = await login(email, password);
      setSession(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={s.container}>
      <div style={s.card}>
        {/* Logo */}
        <div style={s.logoRow}>
          <div style={s.logoDot} />
          <span style={s.logoText}>
            NSR <span style={{ color: "#D4620D" }}>|</span> Auditorias
          </span>
        </div>

        <h1 style={s.title}>Bienvenido</h1>
        <p style={s.subtitle}>Panel de Administración</p>

        <form onSubmit={handleSubmit}>
          <div style={s.field}>
            <label style={s.label}>Email</label>
            <input
              style={s.input}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@admin.com"
              required
            />
          </div>
          <div style={s.field}>
            <label style={s.label}>Contraseña</label>
            <input
              style={s.input}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          {error && <p style={s.error}>{error}</p>}

          <button
            style={{ ...s.button, ...(loading ? s.buttonDisabled : {}) }}
            type="submit"
            disabled={loading}
          >
            {loading ? "Ingresando..." : "Ingresar"}
          </button>
        </form>
      </div>
    </div>
  );
}

const s = {
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "var(--bg)",
    padding: 20,
  },
  card: {
    borderRadius: 20,
    padding: "36px 36px 40px",
    width: "100%",
    maxWidth: 400,
    boxShadow: "0 4px 32px rgba(20,20,14,0.10)",
  },
  logoRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginBottom: 28,
  },
  logoDot: {
    width: 32,
    height: 32,
    borderRadius: 9,
    background: "#D4620D",
    flexShrink: 0,
  },
  logoText: {
    fontSize: 16,
    fontWeight: 800,
    color: "var(--text)",
    letterSpacing: "-0.4px",
  },
  title: {
    fontSize: 24,
    fontWeight: 800,
    color: "var(--text)",
    margin: "0 0 4px",
    letterSpacing: "-0.4px",
  },
  subtitle: {
    fontSize: 14,
    color: "var(--text-2)",
    margin: "0 0 28px",
    fontWeight: 500,
  },
  field: { marginBottom: 16 },
  label: {
    display: "block",
    color: "var(--text-2)",
    fontSize: 12,
    marginBottom: 7,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  input: {
    width: "100%",
    padding: "12px 14px",
    borderRadius: 12,

    background: "var(--bg)",
    color: "var(--text)",
    fontSize: 14,
    boxSizing: "border-box",
    outline: "none",
    fontFamily: "Montserrat, sans-serif",
  },
  error: {
    color: "#C43515",
    fontSize: 13,
    marginBottom: 12,
    fontWeight: 600,
    background: "#fef2f2",
    borderRadius: 8,
    padding: "8px 12px",
  },
  button: {
    width: "100%",
    padding: "14px",
    borderRadius: 12,
    border: "none",
    background: "#D4620D",
    color: "#fff",
    fontSize: 15,
    fontWeight: 700,
    cursor: "pointer",
    marginTop: 8,
    fontFamily: "Montserrat, sans-serif",
    boxShadow: "0 4px 14px rgba(212,98,13,0.30)",
    transition: "opacity 0.15s",
  },
  buttonDisabled: { opacity: 0.6, cursor: "not-allowed" },
};
